import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * Very similar to DeferredValuePromise<T>.
 * Easy way to construct a promise, typically for testing, and then trigger the resolution
 * at a later time.
 */
export class ManualPromise {
  constructor() {
    _defineProperty(this, "promise", void 0);
    _defineProperty(this, "_isResolved", false);
    this.resolve = this.resolve.bind(this);
    this.reject = this.reject.bind(this);
    this.then = this.then.bind(this);
    this.catch = this.catch.bind(this);
    this.finally = this.finally.bind(this);

    // capture the promise resolution functions for later use
    this.promise = new Promise((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });
  }
  resolve(value) {
    this._isResolved = true;
    this._resolve(value);
  }
  reject(reason) {
    this._isResolved = true;
    this._reject(reason);
  }

  /* Plumbing so that "implements Promise<T>" is true */
  then(onfulfilled, onrejected) {
    return this.promise.then(onfulfilled, onrejected);
  }
  get [Symbol.toStringTag]() {
    return "ManualPromise";
  }
  catch(onrejected) {
    return this.promise.catch(onrejected);
  }
  finally(onfinally) {
    return this.promise.finally(onfinally);
  }

  /** Returns true if promise has been fulfilled or rejected, false if promise is pending */
  get isResolved() {
    return this._isResolved;
  }
}
//# sourceMappingURL=ManualPromise.js.map
